import {
	SimpleForm,
	TextInput,
	required,
	ReferenceArrayInput,
	AutocompleteArrayInput,
	useRecordContext,
	useNotify,
	useRefresh,
	useDataProvider,
	Button,
	Toolbar,
	SaveButton,
	DeleteButton
} from 'react-admin';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { useState } from 'react';

// Reindex library button
const ReindexLibraryButton = () => {
	const record = useRecordContext();
	const notify = useNotify();
	const refresh = useRefresh();
	const dataProvider = useDataProvider();
	const [loading, setLoading] = useState(false);

	const handleReindex = async () => {
		if (!record?.id) return;

		setLoading(true);
		try {
			const json = await dataProvider.reindexLibrary( record.id );

			if (json.success) {
				notify(`Reindexed ${json.successful} of ${json.total} documents across ${json.topics_count} topics`, { type: 'success' });
				refresh();
			} else {
				notify(json.message || 'Reindexing failed', { type: 'error' });
			}
		} catch (error) {
			console.error('Reindex error:', error);
			notify(`Error: ${error.message}`, { type: 'error' });
		} finally {
			setLoading(false);
		}
	};

	const topicCount = record?.topics?.length || 0;

	return (
		<Button
			label={`Reindex All Documents (${topicCount} topics)`}
			onClick={handleReindex}
			variant="outlined"
			disabled={topicCount === 0 || loading}
			sx={{ marginLeft: 2 }}
		>
			<CloudSyncIcon />
		</Button>
	);
};

// Custom toolbar with reindex button
export const LibraryEditToolbar = () => {
	const record = useRecordContext();

	return (
		<Toolbar>
			<SaveButton />
			{record?.id && <ReindexLibraryButton />}
			<DeleteButton />
		</Toolbar>
	);
};

export const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<TextInput source="description" fullWidth helperText="Used for internal documentation purposes only." />
		<ReferenceArrayInput source="topic_ids" reference="topics">
			<AutocompleteArrayInput
				optionText="name"
				label="Topics"
				helperText="Select topics to associate with this library"
			/>
		</ReferenceArrayInput>
	</SimpleForm>
);

export const FormFieldsWithToolbar = (
	<SimpleForm toolbar={<LibraryEditToolbar />}>
		<TextInput source="name" validate={required()} />
		<TextInput source="description" fullWidth helperText="Used for internal documentation purposes only." />
		<ReferenceArrayInput source="topic_ids" reference="topics">
			<AutocompleteArrayInput
				optionText="name"
				label="Topics"
				helperText="Select topics to associate with this library"
			/>
		</ReferenceArrayInput>
	</SimpleForm>
);
